/* eslint-disable */
import store from "../store/index";
import httpResource from "../http/httpResource";

export function parseApierror(error) {
  console.log("parseapierror", error);
  try {
    if (
      error &&
      error.hasOwnProperty("response") &&
      error.response.hasOwnProperty("data")
    ) {
      const apierror = error.response.data;
      return {
        status: apierror.status,
        statusCode: error.status,
        timestamp: apierror.timestamp,
        message: apierror.message
      };
    }
  } catch (parseError) {
    return {
      status: "INTERNAL_SERVER_ERROR",
      statusCode: 500,
      timestamp: new Date(),
      message: "Server is not responding.."
    };
  }
}


// WEBPACK FOOTER //
// ./src/util/utils.js